import { distance } from 'fastest-levenshtein';

import includes from 'lodash-es/includes';
import sortBy from 'lodash-es/sortBy';

const distancePercentageThreshold = 0.25;
const minimumLengthForSubstringChecking = 2;

export function areWordsSimilar(word1: any, word2: any) {
  word1 = word1.toLocaleLowerCase();
  word2 = word2.toLocaleLowerCase();
  const [shorterWord, longerWord] = sortBy(
    [word1, word2],
    (word) => word.length,
  );
  const distancePercentage = distance(word1, word2) / shorterWord.length;
  return (
    distancePercentage <= distancePercentageThreshold ||
    (includes(longerWord, shorterWord) &&
      minimumLengthForSubstringChecking < shorterWord.length)
  );
}
